var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.01 5.13H4.14001C2.67646 5.13 1.48999 6.31645 1.48999 7.78V18.59C1.48999 20.0536 2.67646 21.24 4.14001 21.24H23.01C24.4736 21.24 25.66 20.0536 25.66 18.59V7.78C25.66 6.31645 24.4736 5.13 23.01 5.13Z",
    stroke: "#EF5226",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.01 9.97H19.45C17.9864 9.97 16.8 11.1564 16.8 12.62V12.96C16.8 14.4236 17.9864 15.61 19.45 15.61H23.01C24.4736 15.61 25.66 14.4236 25.66 12.96V12.62C25.66 11.1564 24.4736 9.97 23.01 9.97Z",
    stroke: "#EF5226",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16992 5.41L17.0399 1.76C18.8199 1.37 20.6498 2.16 21.5898 3.73L22.4398 5.14",
    stroke: "#EF5226",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.58ed47d15e333332ad205af5a7bf259b.svg";
export { ForwardRef as ReactComponent };